export default "__VITE_ASSET__DWKiv$Wp__"